module.exports = __webpack_public_path__ + "img/video-bg-sm.c469f1e8.jpg";